// @flow

import React from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import FroalaEditor from 'froala-editor';
import jquery from 'jquery';

import {AddDocumentLinkPopup} from './AddDocumentLinkPopup';

const getNamespacesEvent = (eventName: string) =>
  `${eventName}.documentLinkFroalaPlugin`;

// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.documentLinkPlugin = function (editor) {
  const containerClass = 'document-link-popup-container';
  let $popup;
  let $btn = editor.$tb.find('.fr-command[data-cmd="documentLinkButton"]');
  let visible = false;

  function createPopupContainer(container) {
    $popup = jquery('<div />')
      .addClass(containerClass)
      .css({position: 'fixed', zIndex: 10})
      .prependTo(container);

    editor.events.$on(editor.$sc, 'scroll', refreshPopupPosition);
    refreshPopupPosition();
    return $popup.get(0);
  }

  function refreshPopupPosition() {
    const {left, top} = editor.button.getPosition($btn);
    $popup.css({left, top});
  }

  function getOrCreatePopupContainer() {
    const container = jquery(editor.$box[0]);

    return (
      jquery(`> .${containerClass}`, container).get(0) ||
      createPopupContainer(container)
    );
  }

  function hideOnClickOutside() {
    jquery(document).on(getNamespacesEvent('mouseup'), (e) => {
      if (!$popup.is(e.target) && $popup.has(e.target).length === 0) {
        hidePopup();
      }
    });
  }

  // Show the popup
  function showPopup() {
    editor.selection.save();

    const container = getOrCreatePopupContainer();
    hideOnClickOutside();
    render(<AddDocumentLinkPopup editor={editor} plugin={this} />, container);
    visible = true;
  }

  // Hide the custom popup.
  function hidePopup() {
    jquery(document).off(getNamespacesEvent('mouseup'));
    unmountComponentAtNode($popup.get(0));
    visible = false;
  }

  function isVisible() {
    return visible;
  }

  // Methods visible outside the plugin.
  return {
    showPopup,
    hidePopup,
    isVisible,
  };
};

// Define an icon and command for the button that opens the custom popup.
FroalaEditor.DefineIcon('documentLinkIcon', {NAME: 'external-link'});

FroalaEditor.RegisterShortcut(
  FroalaEditor.KEYCODE.E,
  'documentLinkButton',
  null,
  'E'
);

FroalaEditor.RegisterCommand('documentLinkButton', {
  title: 'Link to procedure, process or policy',
  icon: 'documentLinkIcon',
  undo: false,
  focus: false,
  popup: false,
  // Buttons which are included in the editor toolbar should have the plugin property set.
  plugin: 'documentLinkPlugin',
  callback: function () {
    if (!this.documentLinkPlugin.isVisible()) {
      this.documentLinkPlugin.showPopup();
    } else {
      if (this.$el.find('.fr-marker')) {
        this.events.disableBlur();
        this.selection.restore();
      }
      this.documentLinkPlugin.hidePopup();
    }
  },
});
